import { AlertFab } from '@juvare/alert-ui/ui/features/alerts';
import { PageHeaderWithImage } from '@juvare/common-web-ui/PageHeader';
import homePageImage from '@juvare/common-web-ui/assets/homePageImage.svg';
import { allowUserSendMessages, requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { OngoingShifts } from '@juvare/missions/ui/features/ongoingShifts';
import { UpcomingShifts } from '@juvare/missions/ui/features/upcoming-shifts';
import { Box, Card } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../Context';
import { Announcements } from '../features/announcements';
import { MissionProvider } from '../features/missions';

export const HomePage: React.FC = () => {
    const { t } = useTranslation('rms');
    const { userState } = React.useContext(AppContext);
    const allowSendMessages = allowUserSendMessages(userState);
    const allowManageMission = requireAnySystemPermission(userState, 'manage-missions', 'manage-all-admin-missions');

    return (
        <Box sx={{ height: '100%', overflow: 'auto' }}>
            <PageHeaderWithImage
                image={homePageImage}
                gradient='blue-dark-angle'
                title={t('appHeader.title', { firstName: userState?.firstName })}
                imageAlt=''
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 4 }}>
                <MissionProvider>
                    {allowManageMission && <OngoingShifts />}
                    <UpcomingShifts />
                </MissionProvider>
                <Card variant='outlined' sx={{ p: 2 }}>
                    <Announcements />
                </Card>
            </Box>
            {allowSendMessages && <AlertFab />}
        </Box>
    );
};
